import { Pipe, PipeTransform } from '@angular/core';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'tokenVaultVerificationDisplay',
  standalone: true,
})
export class TokenVaultVerificationDisplayPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    return CoreNiceLabelUtils.tokenVaultVerification(value);
  }
}
